// KandyBunniez: copy the photo strip for each menu item into the mobile menu drawer.
// Horizon re-renders the drawer after load, so keep re-inserting with a MutationObserver.
function kbInsertStrips() {
  document.querySelectorAll('template[data-kb-strip]').forEach((tpl) => {
    const panel = document.getElementById('link-' + tpl.dataset.kbStrip);
    if (!panel || panel.querySelector('.kbm-strip')) return;
    const nav = panel.querySelector('.menu-drawer__nav-buttons');
    const frag = tpl.content.cloneNode(true);
    if (nav) nav.after(frag); else panel.prepend(frag);
  });
}
let kbQueued = false;
function kbQueue() {
  if (kbQueued) return;
  kbQueued = true;
  requestAnimationFrame(() => { kbQueued = false; kbInsertStrips(); });
}
kbInsertStrips();
document.addEventListener('DOMContentLoaded', kbInsertStrips);
document.addEventListener('toggle', kbQueue, true);
document.addEventListener('click', (e) => {
  if (e.target instanceof Element && e.target.closest('.header__icon--menu, .menu-drawer summary')) kbInsertStrips();
}, true);
new MutationObserver(kbQueue).observe(document.documentElement, { childList: true, subtree: true });
